import { TemplateService } from '../../services/template.service';
import { Chart } from 'chart.js';
import * as _ from 'lodash';
import { ApiService } from '../../services/api.service';
import { HttpParams } from '@angular/common/http';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { CALENDAR_LOCALE } from '../../services/constant';
import { SendEmailModalComponent } from './sendEmailModal/send-email-modal.component';
var EmailDashboardComponent = (function () {
    function EmailDashboardComponent(apiService, translate, template, modalService) {
        this.apiService = apiService;
        this.translate = translate;
        this.template = template;
        this.modalService = modalService;
        this.currentPage = 1;
        this.itemsPerPage = 40;
        this.totalItems = 0;
        this.allBuyerEmailsReport = null;
        this.allBuyerNamesReport = null;
        this.loading_main = false;
        this.datastatus = [];
        this.tableData = [];
        this.selectedCompany = null;
        this.branchList = null;
        this.selectedBranch = null;
        this.allBranchList = null;
        this.startDate = null;
        this.endDate = null;
        this.calendarLocale = CALENDAR_LOCALE.TH;
        this.sortBy = null;
        this.checkdate = null;
        this.sortMode = null;
        this.sentdata = null;
        this.searchingBuyerName = false;
        this.searchingEmail = false;
        this.params = null;
        this.name = '';
        this.placeholder = 'Search Email';
        this.keyword = 'name';
        this.historyHeading = 'Recently selected';
        this.emailList = ['a@a.com', 'b@b.com'];
    }
    EmailDashboardComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.startDate = new Date();
        this.startDate.setDate(this.startDate.getDate() - 60);
        this.endDate = new Date();
        this.defaultStartDate = moment(this.startDate).format('DD/MM/YYYY');
        this.defaultEndDate = moment(this.endDate).format('DD/MM/YYYY');
        this.subs = this.translate.onLangChange.subscribe(function (event) {
            _this.loadInitData();
            _this.searchButtonClicked();
        });
        this.loadInitData();
        this.searchButtonClicked();
    };
    EmailDashboardComponent.prototype.generateChart = function () {
        this.sentChart = new Chart('sentChart', {
            type: 'doughnut',
            data: {
                datasets: [{
                        label: 'Sent Chart',
                        data: [this.transactions_sent, this.transactions_failed],
                        backgroundColor: [
                            '#69a769',
                            '#5b5a5a',
                        ],
                        borderColor: [
                            '#ededed',
                            '#ededed',
                        ],
                        borderWidth: 1
                    }]
            },
            options: {
                responsive: true,
                tooltips: {
                    enabled: false,
                },
                cutoutPercentage: 60
            }
        });
        this.errorChart = new Chart('errorChart', {
            type: 'doughnut',
            data: {
                datasets: [{
                        label: 'Failed Chart',
                        data: [this.transactions_failed, this.transactions_sent],
                        backgroundColor: [
                            '#cc0000',
                            '#6F6E6E'
                        ],
                        borderColor: [
                            '#ededed',
                            '#ededed',
                        ],
                        borderWidth: 1
                    }]
            },
            options: {
                tooltips: {
                    enabled: false,
                },
                cutoutPercentage: 60
            }
        });
    };
    EmailDashboardComponent.prototype.pageChanged = function () {
        this.sentdata = 1;
        this.loadData(this.currentPage);
    };
    EmailDashboardComponent.prototype.ngOnDestroy = function () {
        this.subs.unsubscribe();
    };
    EmailDashboardComponent.prototype.searchButtonClicked = function () {
        this.currentPage = 1;
        this.sortBy = null;
        this.sortMode = null;
        this.status = null;
        this.loadData();
    };
    EmailDashboardComponent.prototype.loadInitData = function () {
        var _this = this;
        if (this.translate.currentLang === 'en') {
            this.calendarLocale = CALENDAR_LOCALE.EN;
        }
        else {
            this.calendarLocale = CALENDAR_LOCALE.TH;
        }
        this.loading_main = true;
        this.rdDocumentType = this.template.getDropdown();
        this.company = [{
                label: this.translate.instant('COMMON.ALL'),
                value: null
            }];
        this.branchList = [{
                label: this.translate.instant('COMMON.ALL'),
                value: null
            }];
        this.apiService.getCompany().subscribe(function (result) {
            _.forEach(result, function (obj) {
                _this.company.push({
                    label: obj.name,
                    value: obj.id
                });
            });
            _this.company = _.uniqBy(_this.company, 'label');
        }, function (error) { return error(status); });
        this.apiService.getBranch().subscribe(function (result) {
            _this.allBranchList = result;
            _this.filterBranchList();
        });
        this.apiService.getAllBuyerEmailsReport().subscribe(function (result) {
            _this.allBuyerEmailsReport = result.all_buyer_emails_report;
        });
        this.apiService.getAllBuyerNamesReport().subscribe(function (result) {
            _this.allBuyerNamesReport = result.all_buyer_name_email_report;
        });
    };
    EmailDashboardComponent.prototype.filterStatus = function (data) {
        this.currentPage = 1;
        this.status = data;
        this.loadData(this.currentPage, this.status);
    };
    EmailDashboardComponent.prototype.loadData = function (page, data) {
        var _this = this;
        this.clickedStartDate = moment(this.startDate).format('DD/MM/YYYY');
        this.clickedEndDate = moment(this.endDate).format('DD/MM/YYYY');
        this.tableData = [];
        this.datastatus = [];
        var sniffTargetArr = [];
        var params = new HttpParams();
        if (this.status) {
            params = params.append('status', this.status);
            sniffTargetArr.push('EMAIL-DASHBOARD.STATUS');
        }
        if (this.selectedCompany) {
            params = params.append('corporate', this.selectedCompany);
            sniffTargetArr.push('FILTER.COMPANY');
        }
        if (this.selectedBranch) {
            params = params.append('corporate_branch', this.selectedBranch);
            sniffTargetArr.push('FILTER.BRANCH');
        }
        if (this.documentNumber) {
            params = params.append('document_number', this.documentNumber);
            sniffTargetArr.push('EMAIL-DASHBOARD.DOC-NUM');
        }
        if (this.buyerName) {
            params = params.append('buyer_name', this.buyerName);
            sniffTargetArr.push('TAX-B2P.FILTER.BUYER');
        }
        if (this.email) {
            params = params.append('email', this.email);
            sniffTargetArr.push('EMAIL-DASHBOARD.EMAIL');
        }
        if (this.sentdata) {
            params = params.append('page', this.currentPage.toString());
            params = params.append('page_size', this.itemsPerPage.toString());
        }
        params = params.append('sent_date_gte', moment(this.startDate).format('YYYY-MM-DD'));
        params = params.append('sent_date_lte', moment(this.endDate).format('YYYY-MM-DD'));
        this.apiService.getEmailDashboard(params).subscribe(function (result) {
            _.forEach(result.results, function (obj) {
                _this.tableData.push({
                    id: obj.id,
                    broker_name: obj.broker_name,
                    buyer_name: obj.buyer_name,
                    email_data: obj.email_data.emails || [],
                    cc_email_data: obj.email_data.cc_list || [],
                    document_number: obj.document_number || [],
                    customer_broker_batch_zip_id: obj.customer_broker_batch_zip_id,
                    status: obj.status,
                    sent_date: obj.sent_date
                });
            });
            if (result) {
                _this.totalItems = result.count;
                _this.emailTotal = result.transactions_sent + result.transactions_failed;
                _this.transactions_sent = result.transactions_sent;
                _this.transactions_failed = result.transactions_failed;
                _this.transactions_wait_for_send = result.transactions_wait_for_send;
                _this.transactions_not_sent = result.transactions_not_sent;
            }
            _this.loading_main = false;
            if (!_this.sentChart && !_this.errorChart) {
                _this.generateChart();
            }
            else {
                _this.sentChart.destroy();
                _this.errorChart.destroy();
                _this.generateChart();
            }
            _this.loading_main = false;
        });
        this.loading_main = false;
        if (this.defaultStartDate !== this.clickedStartDate || this.defaultEndDate !== this.clickedEndDate) {
            sniffTargetArr.push('EMAIL-DASHBOARD.SENT-DATE');
        }
        if (page == null || data) {
            var sniffTarget = sniffTargetArr.join(', ');
            this.sniff('SEARCH', sniffTarget);
        }
    };
    Object.defineProperty(EmailDashboardComponent.prototype, "yearRange", {
        get: function () {
            var thisYear = (new Date()).getFullYear();
            return (thisYear - 40) + ':' + thisYear;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EmailDashboardComponent.prototype, "dateRange", {
        get: function () {
            if (!this.startDate && !this.endDate) {
                return null;
            }
            var start = this.startDate ? moment(this.startDate).format('DD/MM/YYYY') : '';
            var end = this.endDate ? moment(this.endDate).format('DD/MM/YYYY') : '';
            return start + ' - ' + end;
        },
        enumerable: true,
        configurable: true
    });
    EmailDashboardComponent.prototype.setMinDate = function () {
        this.minDate = this.startDate;
    };
    EmailDashboardComponent.prototype.setMaxDate = function () {
        this.maxDate = this.endDate;
    };
    EmailDashboardComponent.prototype.clearData = function () {
        this.transactions_failed = null;
        this.transactions_wait_for_send = null;
        this.transactions_not_sent = null;
        this.transactions_sent = null;
        this.datastatus = null;
        this.startDate = new Date();
        this.startDate.setDate(this.startDate.getDate() - 60);
        this.rdDocumentType = null;
        this.branchList = null;
        this.company = null;
        this.email = null;
        this.endDate = new Date();
        this.sortBy = null;
        this.sortMode = null;
        this.totalItems = 0;
        this.checkdate = null;
        this.currentPage = 1;
        this.selectedBranch = null;
        this.params = null;
        this.selectedCompany = null;
        this.documentNumber = null;
        this.buyerName = null;
        this.loadInitData();
        this.searchButtonClicked();
    };
    EmailDashboardComponent.prototype.filterBranchList = function () {
        var _this = this;
        this.branchList = [{
                label: this.translate.instant('COMMON.ALL'),
                value: null
            }];
        _.forEach(this.allBranchList, function (obj) {
            if (_this.selectedCompany == null || obj.corporate == _this.selectedCompany) {
                _this.branchList.push({
                    label: obj.full_name,
                    value: obj.id
                });
            }
        });
    };
    EmailDashboardComponent.prototype.stopPropagation = function (event) {
        event.stopPropagation();
    };
    EmailDashboardComponent.prototype.openMailModal = function (index) {
        var modal = this.modalService.open(SendEmailModalComponent, { keyboard: false, centered: true });
        var modalContent = modal.componentInstance;
        modalContent.modalData = this.tableData[index];
    };
    EmailDashboardComponent.prototype.sniff = function (action, target) {
        var data = {
            action: action,
            address: 'EMAIL_DASHBOARD',
            target: target
        };
        this.apiService.sniff(data).subscribe();
    };
    return EmailDashboardComponent;
}());
export { EmailDashboardComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/features/email-dashboard/email-dashboard.component.ts.pre-build-optimizer.js